import { styled } from 'styled-components'

export const LoadingContainer = styled.div`
  display: flex;
  margin: auto;
  height: inherit;
  align-items: center;
  justify-content: center;
`
